<template>
  <!-- the time of the most tracked person; a click opens the "Spent time" popup under it -->
  <Dropdown
    stickLeft closeOnClick overflow
    @click.stop
  >
    <template v-slot:wrapper>
      <span
        v-if="isTracking"
        class="size-1.5 shrink-0 mr-1.5 rounded-full bg-accent animate-dot-pulse"
      ></span>
      <IntervalHolder
        class="mr-2 text-label font-bold text-accent"
        :isActive="spentTimes[0].ttbuObj.timeSlots?.length ? spentTimes[0].ttbuObj.trackingOnline : false"
        :ttbu="spentTimes[0].ttbuObj"
      />
    </template>
    <template v-slot:items>
      <SpentTimeList :task="task" :spentTimes="spentTimes" />
    </template>
  </Dropdown>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import IntervalHolder from '@/components/elements/IntervalHolder';
import SpentTimeList from '@/components/elements/SpentTimeList.vue';

const props = defineProps({
  task: Object,
  // from useTaskSpentTimes, not empty: people who tracked the task, most tracked first
  spentTimes: Array,
});

const store = useStore();

const activeTrackingTask = computed(() => store.state.task.activeTrackingTask);

const isTracking = computed(() => !!props.spentTimes[0].ttbuObj.trackingOnline
  || activeTrackingTask.value?.id === props.task.id);
</script>
